<template>
  <div class="cf-flex cf-75-box">
    <div
      :class="[
        'cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-full-width',
        {
          'cf-background-primary-shade': !isDisabled,
          'cf-background-gray-2': isDisabled
        }]"
    >
      <h2
        :class="[
          'cf-title cf-title--4',
          {
            'cf-title--brand-primary': !isDisabled,
            'cf-title--black': isDisabled
          }]"
      >
        {{ cost }}
      </h2>

      <h6 class="cf-title cf-title--6">
        {{ currency }}
      </h6>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'CfOfferPointDisplay',

    props: {
      cost: {
        type: Number,
        required: true
      },

      currency: {
        type: String,
        required: true
      },

      isDisabled: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
